module.exports = __webpack_public_path__ + "img/sec5_7.ce81ca1e.jpg";